import {
  CitationData,
  RuleBasedCitation,
  References,
  Footnote,
  Citation,
} from "./types";

export type CitationMap = Map<string, Citation>;

export function rearrangeCitations(
  ruleValues: RuleBasedCitation[],
): References {
  if (!ruleValues || ruleValues.length === 0)
    return { citations: [], footnotes: [] };

  // Helper function to add citation to the map
  const addCitationToMap = (map: CitationMap, citation: CitationData) => {
    if (!map.has(citation.id)) {
      const { id, ...metadata } = citation;
      map.set(citation.id, {
        id,
        metadata,
      });
    }
  };

  //map citation id to citation
  const citationsMap: CitationMap = ruleValues.reduce((accMap, ruleValue) => {
    if (!ruleValue.ruleCitations) {
      console.warn("No ruleCitations for rule:", ruleValue);
      return accMap;
    }
    ruleValue.ruleCitations.forEach((citation) => {
      if (citation) {
        addCitationToMap(accMap, citation);
      }
    });

    return accMap;
  }, new Map<string, Citation>());

  // Generate an array of citation IDs for index lookups
  const citationIndexesSet = Array.from(citationsMap.keys());

  // Map of ruleValue indexes to relevant citation details
  const footnotes: Footnote[] = [];
  ruleValues.forEach((ruleValue, ruleValueIndex) => {
    ruleValue.ruleCitations
      ?.filter((ruleCitation) => ruleCitation && ruleCitation.id) //filter out invalid citations
      .forEach((ruleCitation) => {
        const citationIndex = citationIndexesSet.indexOf(ruleCitation.id) + 1; // 1-based index
        if (citationIndex > 0)
          footnotes.push({
            id: (ruleValueIndex + 1).toString(),
            citationid: citationIndex.toString(),
            text: ruleValue.text,
          });
      });
  });

  const citations = Array.from(citationsMap.values());

  return { citations, footnotes };
}

export function convertToMarkdownList(inputString: string = "") {
  // Split the input string into lines
  const lines = inputString.split(/\r?\n/);
  let markdownList = "";

  lines.forEach((line, index) => {
    // Skip empty lines
    if (line.trim() !== "") {
      markdownList += `${index + 1}. ${line.trim()}\n`;
    }
  });

  return markdownList;
}

export function escapeMarkdown(str: string) {
  return str.replace(/([#*_~|'`])/g, "\\$1");
}

// function splitByFootnotes(str: string) {
//   return str.split(/( \^\d+(?: \^\d+)*)/g);
// }

export function annotationMarkdown(
  citationIndex: string,
  footnoteIndex: string,
  footnoteText: string, //TODO: derive from note and don't pass this
) {
  return `[[${citationIndex}]](${citationIndex}/${footnoteIndex} '${escapeMarkdown(
    footnoteText,
  )}')`;
}

export function addAnnotations(str: string, references: References): string {
  if (!str) return "";
  const citations = references?.citations;
  const footnotes = references?.footnotes;
  // Return the original string if there are no citations
  if (
    !citations ||
    !footnotes ||
    citations.length === 0 ||
    footnotes.length === 0
  )
    return str;

  return str.replace(/ \^(\d+)/g, (match) => {
    const footnoteIndex = match.replace(" ^", "");
    const footnote = footnotes.find((f) => f.id === footnoteIndex);
    if (!footnote) return match;

    // Build the Markdown annotation
    return annotationMarkdown(
      footnote.citationid,
      footnoteIndex,
      footnote.text,
    );
  });
}

// export function addAnnotationsByRuleValues(
//   str: string,
//   footNotes: Footnote[],
//   withDebug = false,
// ): string {
//   if (!str) return "";
//   const parts = splitByFootnotes(str); //split by footnote groups
//   if (!parts.length || !footNotes) return str;
//
//   const converted = parts.map((part, partIndex) => {
//     if (partIndex % 2 === 0) return part; //text
//
//     //get rule numbers
//     const ruleNums = part.split(/ \^(\d+)/g).filter(
//       (r) => !isNaN(parseInt(r)) && footNotes.has(parseInt(r)), //filter out invalid footnotes/no citation defined
//     );
//
//     //replace rule numbers with citations
//     const citations = ruleNums.flatMap((ruleNum) =>
//       footNotes.get(parseInt(ruleNum)),
//     );
//
//     //make sure the citations are unique and sort by citation index
//     const sortedCitations = Array.from(
//       new Map(
//         citations.map((citation: FootnoteData) => [citation.index, citation]),
//       ).values(),
//       (citation) => ({
//         ...citation,
//       }),
//     ).sort((a, b) => a.index - b.index);
//     return sortedCitations
//       .map((fn) =>
//         annotationMarkdown(fn.index.toString(), fn.title, fn.id, withDebug),
//       )
//       .join("");
//   });
//   return converted.join("");
// }
